import { Grid, Typography } from "@material-ui/core";
import millify from "millify";
import NumberFormat from "react-number-format";
import { useSelector } from "react-redux";

const ETFFinancials = (props) => {
  const values = props.values;
  const marketingCap = values?.Assets_Under_Management?.toString().split(".");
  const marketingCapInt = marketingCap ? marketingCap[0]?.length : 0;
  const isDesktopOrLaptop = useSelector((state) => state.screenSize.value);
  const t = props.t;

  return (
    <Grid container style={{ justifyContent: "center", paddingTop: "10px" }}>
      <Grid
        item
        xs={isDesktopOrLaptop ? 6 : 12}
        style={{
          paddingTop: "10px",
          paddingRight: "5px",
        }}
      >
        <Grid
          container
          style={{
            backgroundColor: "#f8faff",
            width: isDesktopOrLaptop ? "80%" : "100%",
            height: "38px",
            display: "flex",
            alignItems: "center",
          }}
        >
          <Grid
            item
            xs={isDesktopOrLaptop ? 6 : 8}
            style={{ display: "flex", justifyContent: "flex-start" }}
          >
            <Typography
              style={{
                fontFamily: "Overpass",
                fontStyle: "normal",
                fontWeight: "bold",
                fontSize: "12px",
                lineHeight: "22px",
                color: "#16063b",
              }}
            >
              {t("previous_close")}
            </Typography>
          </Grid>
          <Grid
            item
            xs={isDesktopOrLaptop ? 6 : 4}
            style={{ display: "flex", justifyContent: "flex-end" }}
          >
            <Typography
              style={{
                fontFamily: "Overpass",
                fontStyle: "normal",
                fontWeight: "bold",
                fontSize: "12px",
                lineHeight: "22px",
                color: "#16063b",
              }}
            >
              {`${values?.Previous_Close} ${props.cur}`}
            </Typography>
          </Grid>
        </Grid>
        <Grid
          container
          style={{
            width: isDesktopOrLaptop ? "80%" : "100%",
            height: "38px",
            display: "flex",
            alignItems: "center",
          }}
        >
          <Grid
            item
            xs={isDesktopOrLaptop ? 6 : 8}
            style={{ display: "flex", justifyContent: "flex-start" }}
          >
            <Typography
              style={{
                fontFamily: "Overpass",
                fontStyle: "normal",
                fontWeight: "bold",
                fontSize: "12px",
                lineHeight: "22px",
                color: "#16063b",
              }}
            >
              {t("week_range_52")}
            </Typography>
          </Grid>
          <Grid
            item
            xs={isDesktopOrLaptop ? 6 : 4}
            style={{ display: "flex", justifyContent: "flex-end" }}
          >
            <Typography
              style={{
                fontFamily: "Overpass",
                fontStyle: "normal",
                fontWeight: "bold",
                fontSize: "12px",
                lineHeight: "22px",
                color: "#16063b",
              }}
            >
              {`${values?.Week_Range_52} ${props.cur}`}
            </Typography>
          </Grid>
        </Grid>
        <Grid
          container
          style={{
            backgroundColor: "#f8faff",
            width: isDesktopOrLaptop ? "80%" : "100%",
            height: "38px",
            display: "flex",
            alignItems: "center",
          }}
        >
          <Grid
            item
            xs={isDesktopOrLaptop ? 6 : 8}
            style={{ display: "flex", justifyContent: "flex-start" }}
          >
            <Typography
              style={{
                fontFamily: "Overpass",
                fontStyle: "normal",
                fontWeight: "bold",
                fontSize: "12px",
                lineHeight: "22px",
                color: "#16063b",
              }}
            >
              Volume
            </Typography>
          </Grid>
          <Grid
            item
            xs={isDesktopOrLaptop ? 6 : 4}
            style={{ display: "flex", justifyContent: "flex-end" }}
          >
            <Typography
              style={{
                fontFamily: "Overpass",
                fontStyle: "normal",
                fontWeight: "bold",
                fontSize: "12px",
                lineHeight: "22px",
                color: "#16063b",
              }}
            >
              {`${values?.Volume} ${props.cur}`}
            </Typography>
          </Grid>
        </Grid>
        <Grid
          container
          style={{
            width: isDesktopOrLaptop ? "80%" : "100%",
            height: "38px",
            display: "flex",
            alignItems: "center",
          }}
        >
          <Grid
            item
            xs={isDesktopOrLaptop ? 6 : 6}
            style={{ display: "flex", justifyContent: "flex-start" }}
          >
            <Typography
              style={{
                fontFamily: "Overpass",
                fontStyle: "normal",
                fontWeight: "bold",
                fontSize: "12px",
                lineHeight: "22px",
                color: "#16063b",
              }}
            >
              {t("legal_Structure")}
            </Typography>
          </Grid>
          <Grid
            item
            xs={6}
            style={{ display: "flex", justifyContent: "flex-end" }}
          >
            <Typography
              style={{
                fontFamily: "Overpass",
                fontStyle: "normal",
                fontWeight: "bold",
                fontSize: "12px",
                lineHeight: "22px",
                color: "#16063b",
              }}
            >
              {values?.Legal_Structure}
            </Typography>
          </Grid>
        </Grid>
        <Grid
          container
          style={{
            backgroundColor: "#f8faff",
            width: isDesktopOrLaptop ? "80%" : "100%",
            height: "38px",
            display: "flex",
            alignItems: "center",
          }}
        >
          <Grid
            item
            xs={isDesktopOrLaptop ? 6 : 8}
            style={{ display: "flex", justifyContent: "flex-start" }}
          >
            <Typography
              style={{
                fontFamily: "Overpass",
                fontStyle: "normal",
                fontWeight: "bold",
                fontSize: "12px",
                lineHeight: "22px",
                color: "#16063b",
              }}
            >
              {t("expense_ratio_x")}
            </Typography>
          </Grid>
          <Grid
            item
            xs={isDesktopOrLaptop ? 6 : 4}
            style={{ display: "flex", justifyContent: "flex-end" }}
          >
            <Typography
              style={{
                fontFamily: "Overpass",
                fontStyle: "normal",
                fontWeight: "bold",
                fontSize: "12px",
                lineHeight: "22px",
                color: "#16063b",
              }}
            >
              {values?.Expense_Ratio_x}
            </Typography>
          </Grid>
        </Grid>
      </Grid>
      <Grid
        item
        xs={isDesktopOrLaptop ? 6 : 12}
        style={{
          paddingTop: isDesktopOrLaptop ? "10px" : "0px",
          paddingLeft: isDesktopOrLaptop ? "5px" : "0px",
        }}
      >
        <Grid
          container
          style={{
            width: isDesktopOrLaptop ? "80%" : "100%",
            height: "38px",
            display: "flex",
            alignItems: "center",
          }}
        >
          <Grid
            item
            xs={isDesktopOrLaptop ? 6 : 8}
            style={{ display: "flex", justifyContent: "flex-start" }}
          >
            <Typography
              style={{
                fontFamily: "Overpass",
                fontStyle: "normal",
                fontWeight: "bold",
                fontSize: "12px",
                lineHeight: "22px",
                color: "#16063b",
              }}
            >
              {t("average_daily_volume")}
            </Typography>
          </Grid>
          <Grid
            item
            xs={isDesktopOrLaptop ? 6 : 4}
            style={{ display: "flex", justifyContent: "flex-end" }}
          >
            <Typography
              style={{
                fontFamily: "Overpass",
                fontStyle: "normal",
                fontWeight: "bold",
                fontSize: "12px",
                lineHeight: "22px",
                color: "#16063b",
              }}
            >
              {`${values?.Average_Daily__Volume} ${props.cur}`}
            </Typography>
          </Grid>
        </Grid>
        <Grid
          container
          style={{
            backgroundColor: "#f8faff",
            width: isDesktopOrLaptop ? "80%" : "100%",
            height: "38px",
            display: "flex",
            alignItems: "center",
          }}
        >
          <Grid
            item
            xs={isDesktopOrLaptop ? 6 : 8}
            style={{ display: "flex", justifyContent: "flex-start" }}
          >
            <Typography
              style={{
                fontFamily: "Overpass",
                fontStyle: "normal",
                fontWeight: "bold",
                fontSize: "12px",
                lineHeight: "22px",
                color: "#16063b",
              }}
            >
              {t("inception_date")}
            </Typography>
          </Grid>
          <Grid
            item
            xs={isDesktopOrLaptop ? 6 : 4}
            style={{ display: "flex", justifyContent: "flex-end" }}
          >
            <Typography
              style={{
                fontFamily: "Overpass",
                fontStyle: "normal",
                fontWeight: "bold",
                fontSize: "12px",
                lineHeight: "22px",
                color: "#16063b",
              }}
            >
              {values?.Inception_Date}
            </Typography>
          </Grid>
        </Grid>
        <Grid
          container
          style={{
            width: isDesktopOrLaptop ? "80%" : "100%",
            height: "38px",
            display: "flex",
            alignItems: "center",
          }}
        >
          <Grid
            item
            xs={isDesktopOrLaptop ? 6 : 8}
            style={{ display: "flex", justifyContent: "flex-start" }}
          >
            <Typography
              style={{
                fontFamily: "Overpass",
                fontStyle: "normal",
                fontWeight: "bold",
                fontSize: "12px",
                lineHeight: "22px",
                color: "#16063b",
              }}
            >
              {t("assets_under_management")}
            </Typography>
          </Grid>
          <Grid
            item
            xs={isDesktopOrLaptop ? 6 : 4}
            style={{ display: "flex", justifyContent: "flex-end" }}
          >
            <Typography
              style={{
                fontFamily: "Overpass",
                fontStyle: "normal",
                fontWeight: "bold",
                fontSize: "12px",
                lineHeight: "22px",
                color: "#16063b",
              }}
            >
              {marketingCapInt < 7 ? (
                millify(
                  values?.Assets_Under_Management
                    ? values?.Assets_Under_Management
                    : 0,
                  {
                    units: [`M ${props.cur}`, `B ${props.cur}`],
                    space: true,
                    precision: 2,
                  }
                )
              ) : (
                <NumberFormat
                  value={
                    values?.Assets_Under_Management
                      ? values?.Assets_Under_Management / 1000
                      : 0 / 1000
                  }
                  thousandSeparator={"'"}
                  displayType="text"
                  suffix={` B ${props.cur}`}
                  decimalScale={2}
                />
              )}
            </Typography>
          </Grid>
        </Grid>
        <Grid
          container
          style={{
            backgroundColor: "#f8faff",
            width: isDesktopOrLaptop ? "80%" : "100%",
            height: "38px",
            display: "flex",
            alignItems: "center",
          }}
        >
          <Grid
            item
            xs={isDesktopOrLaptop ? 6 : 8}
            style={{ display: "flex", justifyContent: "flex-start" }}
          >
            <Typography
              style={{
                fontFamily: "Overpass",
                fontStyle: "normal",
                fontWeight: "bold",
                fontSize: "12px",
                lineHeight: "22px",
                color: "#16063b",
              }}
            >
              {t("number_of_holdings")}
            </Typography>
          </Grid>
          <Grid
            item
            xs={isDesktopOrLaptop ? 6 : 4}
            style={{ display: "flex", justifyContent: "flex-end" }}
          >
            <Typography
              style={{
                fontFamily: "Overpass",
                fontStyle: "normal",
                fontWeight: "bold",
                fontSize: "12px",
                lineHeight: "22px",
                color: "#16063b",
              }}
            >
              {values?.Number_of_Holdings}
            </Typography>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default ETFFinancials;
